export default __webpack_public_path__ + "static/media/GuessJobs2_15.e75ed052.png";